
function loadViewCount() {
  let viewCountEls = document.querySelectorAll('[data-view-count]');
  viewCountEls = Array.from(viewCountEls);
  const viewIds = viewCountEls.map((el) => el.dataset.itemId);

  if (viewIds.length > 0) {
    fetch(`/actions/petro-helper/view-count/view?ids=${viewIds.join(',')}`)
      .then((response) => response.json())
      .then((response) => {
        viewCountEls.forEach((el) => {
          const itemId = el.dataset.itemId;
          if (itemId) {
            el.textContent = response[itemId].totalCount;
          }
        });
      })
      .catch((error) => {
        console.error("Error fetching view counts:", error);
      });
  }
}

function incrementViewCount() {
  let elementEl = document.querySelector('[data-element-id]');
  let incrementEl = document.querySelector('[data-view-count-increment]');
  if (elementEl) {
    const elementId = elementEl.dataset.elementId;

    if (elementId) {
      fetch(`/actions/petro-helper/view-count/increment`, {
        method: 'POST',
        body: new URLSearchParams({
          id: elementId
        })
      })
        .then((response) => response.json())
        .then((response) => {
          if (incrementEl) {
            incrementEl.textContent = response;
          }
        })
        .catch((error) => {
          console.error("Error fetching view counts:", error);
        });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.setTimeout(() => {
    loadViewCount();
    incrementViewCount();
  }, 2000);
});

// document.body.addEventListener('htmx:afterSwap', function(evt, detail) {
//   console.log(evt, detail);
//   // reload loadview count
//   loadViewCount();
// });